import * as React from 'react'
import * as Styles from './HomeStackBlock.style'
// tslint:disable-next-line
const {LazyLoadImage} = require('react-lazy-load-image-component')

interface HomeLimitBarProp {
    data: {
        name: string,
        contents: ItemContents[]
    }
}

interface ItemContents {
    style_name: string,
    cover_urls: CoverUrl[]
}

interface CoverUrl {
    advertisement_url_1: string,
    cover_url?: string
}

function HomeStackBlock(props: HomeLimitBarProp) {
    const content = props.data.contents[0].cover_urls
    const clickHandle = (url: string) => {
        window.location.href = url
    }
    return (
        <div className={Styles.MainStackBlock}>
            <div className={Styles.titleName}>{props.data.name}</div>
            <div className={Styles.MainStackBlockWrap}>
                <div className={Styles.leftStackBlock} onClick={() => clickHandle(content[0].advertisement_url_1)}>
                    {/*<img src={content[0].cover_url} alt=""/>*/}
                    <LazyLoadImage
                        alt={content[0].cover_url}
                        effect="blur"
                        src={content[0].cover_url}
                    />
                </div>
                <div className={Styles.rightStackBlock}>
                    <div style={{position: 'absolute', top: 0}} onClick={() => clickHandle(content[1].advertisement_url_1)}>
                        {/*<img src={content[1].cover_url} alt=""/>*/}
                        <LazyLoadImage
                            alt={content[1].cover_url}
                            effect="blur"
                            src={content[1].cover_url}
                        />
                    </div>
                    <div style={{position: 'absolute', bottom: 0}} onClick={() => clickHandle(content[2].advertisement_url_1)}>
                        {/*<img src={content[2].cover_url} alt=""/>*/}
                        <LazyLoadImage
                            alt={content[2].cover_url}
                            effect="blur"
                            src={content[2].cover_url}
                        />
                    </div>
                </div>
            </div>
    </div>
    )

}

export default HomeStackBlock



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeStackBlock/HomeStackBlock.tsx